import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Play } from 'lucide-react';
import { heroImages } from '../mock';

export default function Hero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroImages.length), 6500);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="hero">
      {heroImages.map((src, i) => (
        <div
          key={i}
          className={`hero-slide ${idx === i ? 'active' : ''}`}
          style={{ backgroundImage: `url(${src})` }}
        />
      ))}
      <div className="hero-overlay" />
      <div className="container-x hero-content">
        <span className="eyebrow text-[#f0b040] mb-4">— Uttar Pradesh's Pride</span>
        <h1 className="font-display text-5xl md:text-7xl font-bold leading-[1.05] max-w-3xl">
          Where the King <br /> Roams Free.
        </h1>
        <p className="mt-6 text-lg md:text-xl max-w-xl text-[#f7e6c2]/90">
          Step into India’s largest lion safari sprawled over 350 hectares of pristine woodland. An encounter with wilderness like no other.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/tickets" className="btn-primary text-base">
            Plan Your Visit <ChevronRight size={18} />
          </Link>
          <Link to="/gallery" className="btn-outline text-base">
            <Play size={16} /> Explore Gallery
          </Link>
        </div>

        {/* Slide dots */}
        <div className="absolute bottom-10 left-6 md:left-0 flex gap-2" style={{ position: 'absolute' }}>
          {heroImages.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1 rounded-full transition-all ${idx === i ? 'w-10 bg-[#f0b040]' : 'w-5 bg-[#fff8ec]/40'}`}
              aria-label={`slide ${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
